




import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import 'select2/dist/js/select2.full.min'

declare const $: any;

@Component({})
export default class Select2 extends Vue {
  @Prop() options!: any;
  @Prop({default: () => []}) data!: any[];
  @Prop() value!: string;
  @Prop() parent!: string;
  @Prop({default: false}) invalid!: boolean;

  $select: any;

  mounted() {
    const options = {...this.options, width: '100%', data: this.data,
      dropdownParent: $(this.parent || 'body'), containerCssClass: this.invalid ? 'invalid' : ''};
    this.$select = $(this.$refs.select).select2(options);
    this.$select.val(this.value).trigger('change');
    this.$select.on('select2:select', e => {
      this.onValueChanged(this.$select.val());
    });
    this.$select.on('select2:unselect', e => {
      this.onUnselect(e.params.data.id);
    });
  }

  destroyed() {
    this.$select.off().select2('destroy');
  }

  @Emit('input') onValueChanged(value) {}

  @Emit('unselect') onUnselect(value) {}

  @Watch('data') onDataChanged(value: any[]) {
    this.$select.empty();
    $(this.$select).select2({data: value, ...this.options, width: '100%'
      ,dropdownParent: $(this.parent || 'body'), containerCssClass: this.invalid ? 'invalid' : ''});
    this.$select.on('select2:select', e => {
      this.onValueChanged(this.$select.val());
    });
    this.$select.on('select2:unselect', e => {
      this.onUnselect(e.params.data.id);
    });
    this.$select.val(this.value);
    this.$select.trigger('change');
  }

  @Watch('value') handleValueChanged(value) {
    this.$select.val(value).trigger('change');

    $(this.$select).select2({...this.options, width: '100%'
      ,dropdownParent: $(this.parent || 'body'), containerCssClass: this.invalid ? 'invalid' : ''});
    this.$select.on('select2:select', e => {
      this.onValueChanged(this.$select.val());
    });
    this.$select.on('select2:unselect', e => {
      this.onUnselect(e.params.data.id);
    });
  }
}
